import { Alert, Box, Button, Divider, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AccordionComponentForSelf from './AccordionComponentForSelf';
import { Icon } from '@iconify/react/dist/iconify.js';
import useResponsive from '../../../../Hooks/useResponsive';
import ChartSection from './ChartSection';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useDispatch } from 'react-redux';
import { appraisalDataPost, getAllSelfAppraisalAssignedLists } from '../../../../redux/features/appraisalSlice';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import Loader3D from '../../../../components/Loader/Loader3D';
import { useNavigate } from 'react-router-dom';

const ActionAreaLanding = ({
  parameters,
  ApiData,
  moduleAverages,
  setModuleAverages,
  allowedRatingModuleNamesAndItsScoresForUsers,
  allowedRatingModuleNamesAndItsScoresForManagers,
  finalDetail,
  managerView,
  appraisalCycleId,
  api,
  dispatchParams,
  formClose,
  viewOnly,
  userID,
  downloadButtonClicked,
  submitOpen,
  setSubmitOpen,
  expandedParameterNames,
  setExpandedParameterNames,
  allParametersName,
  isAllExpanded,
  toggleExpandAll,
}) => {
  const navigate = useNavigate();
  const { appraisalPostLoading } = useSelector((state) => state.appraisal);
  const { enqueueSnackbar } = useSnackbar();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const dispatch = useDispatch();
  const mdUp = useResponsive('up', 'md');
  const [data, setData] = useState(ApiData);

  const [touchedFields, setTouchedFields] = useState({});
  const [errors, setErrors] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const submitFunction = () => {
    console.log('moduleaverages', moduleAverages);
    console.log('finalDetails', finalDetail);
    dispatch(
      appraisalDataPost({
        ...data,
        appraisalCycleId: appraisalCycleId,
        isManager: managerView ? true : false,
        userID: userID || null,
      })
    ).then((res) => {
      if (res.payload.status === 'success') {
        enqueueSnackbar(res.payload.message, {
          variant: 'success',
        });
        formClose(false);
        dispatch(api(dispatchParams));
      } else {
        enqueueSnackbar(res.payload.message, {
          variant: 'error',
        });
      }
    });
  };
  const submitPopUp = () => {
    const hasValidErrors = Object.values(errors).some((val) => typeof val === 'string' && val.trim() !== '');
    if (hasValidErrors) {
      console.warn('Validation errors exist. Fix them before submitting.');
      return setSubmitDisabled(true);
    }
    setSubmitDisabled(false);
    setConfirmOpen(true);
  };
  const submitButtonOpenClick = () => {
    // setExpandedParameterNames([]);
    setSubmitOpen((prev) => !prev);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box mb={1}>
        <Button
          sx={{
            visibility: downloadButtonClicked ? 'hidden' : 'visible',
            ml: 0.9,
            minWidth: '130px',
            fontSize: '0.6rem',
            borderRadius: '4px',
            boxShadow: 'none',
            bgcolor: isAllExpanded ? '#e0e0e0' : 'transparent',
            color: '#424242',
            borderColor: '#bdbdbd',
            '&:hover': {
              bgcolor: '#bdbdbd',
              color: 'white',
              border: '1px solid black',
            },
          }}
          variant={isAllExpanded ? 'contained' : 'outlined'}
          onClick={toggleExpandAll}
          size="small"
          startIcon={<Icon icon="mdi:arrow-expand" height={13} width={13} />}
        >
          {isAllExpanded ? 'Collapse All' : 'Expand All'}
        </Button>
      </Box>
      <Box
        sx={{
          height: '100%',
          // maxHeight: '80vh',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
          px: 1,
          pb: 2,
        }}
      >
        {Array.isArray(parameters) &&
          parameters.map((p) => (
            <AccordionComponentForSelf
              key={p}
              title={p}
              details={data[p]}
              expandedParameterNames={expandedParameterNames}
              setExpandedParameterNames={setExpandedParameterNames}
              mainData={data}
              setData={setData}
              parameters={parameters}
              touchedFields={touchedFields}
              setTouchedFields={setTouchedFields}
              errors={errors}
              setErrors={setErrors}
              moduleAverages={moduleAverages}
              setModuleAverages={setModuleAverages}
              managerView={managerView}
              viewOnly={viewOnly}
              downloadButtonClicked={downloadButtonClicked}
            />
          ))}
      </Box>
      <Box>
        <Box>
          <Button
            sx={{
              visibility: downloadButtonClicked ? 'hidden' : 'visible',
              ml: 0.9,
              minWidth: '170px',
              fontSize: '0.7rem',
              borderRadius: '4px',
              boxShadow: 'none',
              bgcolor: 'transparent',
              color: '#424242',
              borderColor: '#bdbdbd',
              '&:hover': {
                bgcolor: '#bdbdbd',
                color: 'white',
                border: '1px solid black',
              },
            }}
            variant={'outlined'}
            onClick={submitButtonOpenClick}
            size="small"
            startIcon={
              <Icon icon={submitOpen ? 'garden:eye-hide-fill-16' : 'carbon:view-filled'} height={16} width={16} />
            }
          >
            {submitOpen ? 'Hide Summary' : 'View Summary And Submit'}
          </Button>
        </Box>
        {submitOpen && (
          <Box p={1} mt={1}>
            <Stack pr={mdUp ? 2 : 0} direction={mdUp ? 'row' : 'column'} spacing={2}>
              <Box flex={3} p={downloadButtonClicked ? 1 : 2} borderRadius={2} boxShadow={4} bgcolor="background.paper">
                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  Self Appraisal Summary
                </Typography>

                <Stack spacing={1}>
                  {allowedRatingModuleNamesAndItsScoresForUsers.map((item, index) => (
                    <Box
                      key={index}
                      display="flex"
                      flexWrap="wrap"
                      justifyContent="space-between"
                      alignItems="center"
                      p={downloadButtonClicked ? 0 : 1}
                      border="1px solid #e0e0e0"
                      borderRadius={2}
                      boxShadow={1}
                      bgcolor="#fafafa"
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          flex: 1,
                          minWidth: downloadButtonClicked ? '' : 120,
                          fontWeight: 500,
                          textAlign: 'center',
                        }}
                      >
                        {item.moduleName.replace(/_/g, ' ').toUpperCase()}
                      </Typography>
                      <Stack
                        direction="row"
                        spacing={0.5}
                        justifyContent="center"
                        alignItems="center"
                        sx={{ flex: 1, minWidth: downloadButtonClicked ? '' : 100 }}
                      >
                        <Typography variant="body2" fontWeight={500}>
                          Score:
                        </Typography>
                        <Typography variant="body2">{item.ratedScore}</Typography>
                      </Stack>
                      <Stack
                        direction="row"
                        spacing={0.5}
                        justifyContent="center"
                        alignItems="center"
                        sx={{ flex: 1, minWidth: downloadButtonClicked ? '' : 120 }}
                      >
                        <Typography variant="body2" fontWeight={500}>
                          Max Rating:
                        </Typography>
                        <Typography variant="body2">{item.maximumRating}</Typography>
                      </Stack>
                    </Box>
                  ))}
                </Stack>
              </Box>
              <Box flex={1} p={2} borderRadius={2} boxShadow={4} bgcolor="background.paper">
                <ChartSection
                  totalScore={finalDetail?.finalScore?.user || 0}
                  outOfScore={finalDetail?.finalScore?.outOfScoreUser || 5}
                  rating={finalDetail?.rating?.user}
                />
              </Box>
            </Stack>
            <Divider sx={{ my: 3 }} />
            {managerView && (
              <Box p={1}>
                <Stack pr={mdUp ? 2 : 0} direction={mdUp ? 'row' : 'column'} spacing={2}>
                  <Box
                    flex={3}
                    p={downloadButtonClicked ? 1 : 2}
                    borderRadius={2}
                    boxShadow={4}
                    bgcolor="background.paper"
                  >
                    <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                      Review Summary
                    </Typography>

                    <Stack spacing={1}>
                      {allowedRatingModuleNamesAndItsScoresForManagers.map((item, index) => (
                        <Box
                          key={index}
                          display="flex"
                          flexWrap="wrap"
                          justifyContent="space-between"
                          alignItems="center"
                          p={downloadButtonClicked ? 0 : 1}
                          border="1px solid #e0e0e0"
                          borderRadius={2}
                          boxShadow={1}
                          bgcolor="#fafafa"
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              flex: 1,
                              minWidth: 120,
                              minWidth: downloadButtonClicked ? '' : 120,
                              textAlign: 'center',
                            }}
                          >
                            {item.moduleName.replace(/_/g, ' ').toUpperCase()}
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={0.5}
                            justifyContent="center"
                            alignItems="center"
                            sx={{ flex: 1, minWidth: downloadButtonClicked ? '' : 100 }}
                          >
                            <Typography variant="body2" fontWeight={500}>
                              Score:
                            </Typography>
                            <Typography variant="body2">{item.ratedScore}</Typography>
                          </Stack>
                          <Stack
                            direction="row"
                            spacing={0.5}
                            justifyContent="center"
                            alignItems="center"
                            sx={{ flex: 1, minWidth: downloadButtonClicked ? '' : 120 }}
                          >
                            <Typography variant="body2" fontWeight={500}>
                              Max Rating:
                            </Typography>
                            <Typography variant="body2">{item.maximumRating}</Typography>
                          </Stack>
                        </Box>
                      ))}
                    </Stack>
                  </Box>
                  <Box flex={1} p={2} borderRadius={2} boxShadow={4} bgcolor="background.paper">
                    <ChartSection
                      totalScore={finalDetail?.finalScore?.manager || 0}
                      outOfScore={finalDetail?.finalScore?.outOfscoreManger || 5}
                      rating={finalDetail?.rating?.manager}
                    />
                  </Box>
                </Stack>
              </Box>
            )}

            {!viewOnly && (
              <Box
                mt={1}
                p={1}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  bgcolor: '#f5f5f5',
                  borderRadius: 2,
                  visibility: downloadButtonClicked ? 'hidden' : 'visible',
                }}
              >
                <Box mr={1}>{submitDisabled && <Alert severity="error"> Please complete required fields</Alert>}</Box>
                <Button
                  disabled={viewOnly}
                  onClick={submitPopUp}
                  variant="contained"
                  endIcon={<Icon icon="iconoir:submit-document" height={20} width={20} />}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: '4px',
                    boxShadow: 3,
                    px: 3,
                    backgroundColor: '#0792fb',
                  }}
                >
                  Submit
                </Button>
              </Box>
            )}

            <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
              <DialogTitle>Confirm Submission</DialogTitle>
              <DialogContent>
                <DialogContentText>Are you sure you want to submit ? This action cannot be undone.</DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setConfirmOpen(false)} color="inherit">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    setConfirmOpen(false);
                    submitFunction();
                  }}
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>

            {appraisalPostLoading && (
              <Box
                sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.6)',
                  zIndex: 1300,
                }}
              >
                <Loader3D />
              </Box>
            )}
          </Box>
        )}
      </Box>
      {downloadButtonClicked && <Box py={10}></Box>}
    </Box>
  );
};

export default ActionAreaLanding;
